module.exports = __webpack_public_path__ + "static/img/success16.f38ed3ee.png";